@if (selected) {
  <ng-content></ng-content>
}
